/**
 * Generated by @openapi-codegen
 *
 * @version 1.0.0
 */
import * as reactQuery from 'app/src/shared/helpers/reactquery'
import { useWelfaredetailsContext, WelfaredetailsContext } from './welfaredetails-context'
import type * as Fetcher from './welfaredetails-fetcher'
import { welfaredetailsFetch } from './welfaredetails-fetcher'
import type * as Schemas from './welfaredetails-schemas'

export type WelfareDetailsRequestListPathParams = {
  templateBasePath: string
}

export type WelfareDetailsRequestListError = Fetcher.ErrorWrapper<{
  status: 400
  payload: {
    /**
     * Error type
     */
    type: string
    /**
     * HTTP status
     */
    status: number
    /**
     * Error message
     */
    title: string
    /**
     * Unique return code
     *
     * @format int32
     */
    rc?: number
  }
}>

export type WelfareDetailsRequestListVariables = {
  pathParams: WelfareDetailsRequestListPathParams
} & WelfaredetailsContext['fetcherOptions']

/**
 * Returns the WelfareDetails
 */
export const fetchWelfareDetailsRequestList = (variables: WelfareDetailsRequestListVariables, signal?: AbortSignal) =>
  welfaredetailsFetch<
    Schemas.WelfareDetails,
    WelfareDetailsRequestListError,
    undefined,
    {},
    {},
    WelfareDetailsRequestListPathParams
  >({
    url: '/{templateBasePath}/pages/welfareDetails',
    method: 'get',
    ...variables,
    signal,
  })

/**
 * Returns the WelfareDetails
 */
export const useWelfareDetailsRequestList = <TData = Schemas.WelfareDetails>(
  variables: WelfareDetailsRequestListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.WelfareDetails, WelfareDetailsRequestListError, TData>,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useWelfaredetailsContext(options)
  return reactQuery.useQuery<Schemas.WelfareDetails, WelfareDetailsRequestListError, TData>({
    queryKey: queryKeyFn({
      path: '/{templateBasePath}/pages/welfareDetails',
      operationId: 'welfareDetailsRequestList',
      variables,
    }),
    queryFn: ({ signal }) => fetchWelfareDetailsRequestList({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type QueryOperation = {
  path: '/{templateBasePath}/pages/welfareDetails'
  operationId: 'welfareDetailsRequestList'
  variables: WelfareDetailsRequestListVariables
}
